import {
  StaticDatePicker as MuiStaticDatePicker,
  StaticDatePickerProps,
} from "@mui/x-date-pickers/StaticDatePicker";

const StaticDatePicker = (props: StaticDatePickerProps) => {
  return <MuiStaticDatePicker {...props} />;
};

export default StaticDatePicker;
